// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import ga from 'vue-ga'
import swipe from '@/components/swipe/swipe'
import spinner from '@/components/common/spinner'
import VueClipboard from 'vue-clipboard2'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'
import '@/utils/zm.js'
import { mapState } from 'vuex'

require('swiper/dist/css/swiper.css')

Vue.use(VueClipboard)

Vue.component(swipe.name, swipe)
Vue.component(spinner.name, spinner)

Vue.use(VueAwesomeSwiper)

// ga统计
ga(router, 'UA-85726094-1')

const { ZM_JSSDK } = window

console.log('===', process.env.NODE_ENV, process.env.BUILD_ENV)

if (ZM_JSSDK) {
  ZM_JSSDK && ZM_JSSDK.setConfig({
    environment: process.env.BUILD_ENV === 'production' ? 'prod' : 'fat',
    logLevel: process.env.BUILD_ENV === 'production' ? 'error' : 'debug',

    // 如果你使用了router并且是history模式
    // 如果你使用了vue-router的hash模式，也是设置history
    history: true,

    // ajax拦截开关，开启后才可以配置trackWhiteList
    interceptor: false,

    // 开启后，pv上报将自动收集url上的参数，添加至pageParam
    // 可设置
    urlParams: true
  })

  ZM_JSSDK && ZM_JSSDK.setDefaults({
    appId: '10565',
    appVersion: '1.0.0'

  // 其他公共字段，appId & appVersion请尽量参考**使用须知**
  })
}

Vue.config.productionTip = false

const { ZMSDK } = window

if ((process.env.BUILD_ENV === 'development' || process.env.BUILD_ENV === 'testing') && ZMSDK) {
  ZMSDK.topic = 'h5sdk_test'
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  computed: mapState(['isLoading'])
}).$mount('#app')
